import type { FaireProductEntity } from "../../entity_types/product";

export const p_kav8s4ynzq: FaireProductEntity = {
  token: "p_kav8s4ynzq",
  type: "product",
  name: "Pine Forest Christmas Stocking – Embroidered Tree Knit",
  brandToken: "b_6djwe8xaft",
  brandName: "Lost Horizons Knitwear – Ships from USA",
  imageUrl:
    "https://cdn.faire.com/fastly/8c670aab9d44fd2ccbd74aa251678b532cd6ec94583a652d7724a37b573521d9.jpeg",
  galleryImageUrls: [],
  priceDollars: 27.5,
  description:
    'The Pine Forest stocking brings a peaceful, woodland vibe to your holiday decor. Knit in soft neutral tones, it features tall evergreens stitched with hand-embroidered detail. A colorful foot with Fair Isle accents adds playful contrast, while a twisted hanging loop completes the rustic charm.\nEach Pine Forest stocking is handmade by women artisans in Nepal, supporting Fair Trade and helping preserve traditional knitting and embroidery techniques.\n\nSize: Approximately 18" from top to toe, 7" opening width.\n\n100% wool.\nFairtrade.\nHandknit in Nepal.\nDry clean/hand-wash only.',
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:20.664Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
